import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getLatestShopError } from '../../state/redux/features/errors/selectors';
const LazyShopErrorWarningModal = React.lazy(
  () => import(/* webpackChunkName: "ConnectedErrorWarningModalg" */ './ShopErrorWarningModal'),
);
import useErrorModalStore from '../../store/error-modal/use-store';
import { getIsErrorModalOpen } from '../../store/error-modal/selectors';

const ConnectedErrorWarningModalWrapper = props => {
  const error = useSelector(state => getLatestShopError(state, props));
  const isErrorModalOpen = useErrorModalStore(getIsErrorModalOpen);

  const { message, crcCode } = error;
  const isOpen = !!(message && crcCode) || isErrorModalOpen;

  return isOpen ? (
    <Suspense fallback={null}>
      <LazyShopErrorWarningModal isOpen={isOpen} {...props} />
    </Suspense>
  ) : null;
};

ConnectedErrorWarningModalWrapper.propTypes = {
  errorsToExclude: PropTypes.arrayOf(PropTypes.string),
};

export default ConnectedErrorWarningModalWrapper;
